import { FC } from 'react';
import { Chip } from '@mui/material';
import { CampaignPartner } from '@libs/types';

interface CampaignPartnerChipProps {
  partner?: CampaignPartner | string;
  size?: 'small' | 'medium';
}

export const CampaignPartnerChip: FC<CampaignPartnerChipProps> = ({ partner, size = 'medium' }) => {
  let backgroundColor;
  let color;

  switch (partner) {
    case CampaignPartner.ZIP_RECRUITER:
      backgroundColor = '#57de70';
      color = '#002325';
      break;
    case CampaignPartner.LINKEDIN:
      backgroundColor = '#0a66c2';
      color = '#ffffff';
      break;
    case CampaignPartner.INDEED:
      backgroundColor = '#f1f1f1';
      color = '#2557a7';
      break;
    case CampaignPartner.APPCAST:
      backgroundColor = '#3138BB ';
      color = '#ffffff';
      break;
    case CampaignPartner.ADZUNA:
      backgroundColor = '#279b37';
      color = '#ffffff';
      break;
    case CampaignPartner.TALROO:
      backgroundColor = '#611cbe';
      color = '#ffffff';
      break;
  }

  return <Chip label={partner} sx={{ backgroundColor, color }} size={size} />;
};
